import { ModuleConfig } from '@/core/module';
import { essRepaymentNotificationsRoutes } from './routes';

export { default as EssRepaymentNotificationsView } from './views/EssRepaymentNotificationsView';

export const EssRepaymentNotificationsModule: ModuleConfig = {
    name: 'ess-repayment-notifications',
    routes: essRepaymentNotificationsRoutes,
    initialize: () => {
        console.log('ESS Repayment Notifications module initialized');
    }
};
